import each from 'lodash/each';
import includes from 'lodash/includes';
import find from 'lodash/find';
import without from 'lodash/without';
const CALLBACKS = {
  before: [],
  after: []
};
window.onbeforeprint = function () {
  each(CALLBACKS.before, function (listener) {
    listener.fn.call(listener.ctx);
  });
};
window.onafterprint = function () {
  each(CALLBACKS.after, function (listener) {
    listener.fn.call(listener.ctx);
  });
};
export function on(name, clb, ctx) {
  // @ts-ignore we can't infer type of this here
  if (!this['on' + name]) {
    return;
  }

  // @ts-ignore we can't infer type of this here
  this['on' + name](clb, ctx);
}
export function off(name, clb, ctx) {
  // @ts-ignore we can't infer type of this here
  if (!this['off' + name]) {
    return;
  }

  // @ts-ignore we can't infer type of this here
  this['off' + name](clb, ctx);
}
export function onbeforeprint(clb, ctx) {
  // @ts-ignore by some reason we expect to have a function here, but not an object of Listener type
  if (includes(CALLBACKS.before, clb)) {
    return;
  }
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function (mql) {
      if (!mql.matches) {
        return;
      }
      clb.call(ctx);
    });
  }
  CALLBACKS.before.push({
    fn: clb,
    ctx: ctx
  });
}
export function offbeforeprint(clb, ctx) {
  const listener = find(CALLBACKS.before, function (listener) {
    return listener.fn === clb && (ctx ? listener.ctx === ctx : true);
  });
  CALLBACKS.before = without(CALLBACKS.before, listener);
}
export function onafterprint(clb, ctx) {
  // @ts-ignore by some reason we expect to have a function here, but not an object of Listener type
  if (includes(CALLBACKS.after, clb)) {
    return;
  }
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function (mql) {
      if (mql.matches) {
        return;
      }
      clb.call(ctx);
    });
  }
  CALLBACKS.after.push({
    fn: clb,
    ctx: ctx
  });
}
export function offafterprint(clb, ctx) {
  const listener = find(CALLBACKS.after, function (listener) {
    return listener.fn === clb && (ctx ? listener.ctx === ctx : true);
  });
  CALLBACKS.after = without(CALLBACKS.after, listener);
}